import React from 'react';
import { Construction } from './Construction/Construction';
import { ConstructionLoc } from './ConstructionLoc/ConstructionLoc';
import { FixFlip } from './FixFlip/FixFlip';
import { Land } from './Land/Land';
import { Model } from './Model/Model';
import { Rental } from './Rental/Rental';
import { BuildRent } from './BuildRent/BuildRent';
import { Bridge } from './Bridge/Bridge';
import { LoanType } from '@apply/constants';
import { useBorrowerLoanType } from '../../queries/BorrowerFields/CoreFields';

export interface PropertyFormProps {
    propertyGuid: string;
    submitted?: boolean;
    disableEditFormOptionBudget?: boolean;
    disableEditFormOptionSpecSheet?: boolean;
    onChangePropertyName?: (propertyId: string, street1: string, street2: string) => void;
    isReview?: boolean;
}

export const PropertyForm: React.FC<PropertyFormProps> = ({
    propertyGuid,
    disableEditFormOptionBudget = false,
    disableEditFormOptionSpecSheet = false,
    isReview = false,
}) => {
    const [loanType] = useBorrowerLoanType();

    switch (loanType) {
        case LoanType.BuildRent:
            return (
                <BuildRent
                    propertyGuid={propertyGuid}
                    disableEditFormOptionBudget={disableEditFormOptionBudget}
                    disableEditFormOptionSpecSheet={disableEditFormOptionSpecSheet}
                    isReview={isReview}
                />
            );
        case LoanType.Construction:
            return (
                <Construction
                    disableEditFormOptionBudget={disableEditFormOptionBudget}
                    disableEditFormOptionSpecSheet={disableEditFormOptionSpecSheet}
                    propertyGuid={propertyGuid}
                    isReview={isReview}
                />
            );
        case LoanType.SubNoteConstruction:
            return (
                <ConstructionLoc
                    propertyGuid={propertyGuid}
                    disableEditFormOptionBudget={disableEditFormOptionBudget}
                    disableEditFormOptionSpecSheet={disableEditFormOptionSpecSheet}
                    isReview={isReview}
                />
            );
        case LoanType.FixFlip:
        case LoanType.SubNoteFixFlip:
            return (
                <FixFlip
                    propertyGuid={propertyGuid}
                    disableEditFormOptionBudget={disableEditFormOptionBudget}
                    disableEditFormOptionSpecSheet={disableEditFormOptionSpecSheet}
                    isReview={isReview}
                />
            );
        case LoanType.Land:
            return (
                <Land
                    propertyGuid={propertyGuid}
                    disableEditFormOptionBudget={disableEditFormOptionBudget}
                    isReview={isReview}
                />
            );
        case LoanType.Model:
            return (
                <Model
                    propertyGuid={propertyGuid}
                    disableEditFormOptionBudget={disableEditFormOptionBudget}
                    disableEditFormOptionSpecSheet={disableEditFormOptionSpecSheet}
                    isReview={isReview}
                />
            );
        case LoanType.Rental:
            return (
                <Rental
                    propertyGuid={propertyGuid}
                    isReview={isReview}
                />
            );
        case LoanType.Bridge:
            return (
                <Bridge
                    propertyGuid={propertyGuid}
                    isReview={isReview}
                />
            );
    }
};
